const form = {

    init: () => {
        const btn = helper.element(".js-subnit");
        const fldbusselect = helper.element(".js-bus-select");
        const fldbus = helper.element("input[name='bus']", true);
        const flds = helper.element(".js-required", true);
        const form = helper.element(".js-form");
        const confirmation = helper.element(".js-confirmation");

        console.log(btn);

        if (fldbusselect && fldbus) {
            Array.from(fldbus).forEach((radio) => {
                radio.addEventListener("change", (e) => {
                    if (e.target.value === "1") {
                        fldbusselect.classList.remove("visually-hidden");
                    } else {
                        fldbusselect.classList.add("visually-hidden");
                    }
                });
            });
        }

        if (flds) {
            //let validate = helper.validate(flds, true);
            //console.log("validation: ", validate);
            Array.from(flds).forEach((fld) => {
                helper.event(fld, "blur change", (e) => {
                    let arr = [];
                    arr.push(fld);
                    let validate = helper.validate(arr, false, true);
                    if (!validate) {
                        btn.setAttribute("disabled", "disabled");
                    } else {
                        let validateall = helper.validate(flds, true, false);
                        if (!validateall) {
                            btn.setAttribute("disabled", "disabled");
                        } else {
                            btn.removeAttribute("disabled");
                        }
                    }
                });
            });
        }

        helper.event(btn, "click", (e) => {
            let validate = helper.validate(flds, true, true);
            btn.setAttribute("disabled", "disabled");
            if (validate) {
                e.preventDefault();
                let data = {};
                let firstname = helper.element("input[name='firstname']");
                let lastname = helper.element("input[name='lastname']");
                let personeelsnummer = helper.element("input[name='personeelsnummer']");
                let email = helper.element("input[name='email']");
                let day = document.querySelector("select[name='day']");
                let bus = helper.element("input[name='bus']:checked");
                let allergy = helper.element("input[name='allergy']");
                let support = helper.element("input[name='support']:checked");
                let departure = document.querySelector("select[name='departure']");
                data.firstname = firstname.value.trim();
                data.lastname = lastname.value.trim();
                data.personeelsnummer = personeelsnummer.value.trim();
                data.email = email.value.trim();
                data.day = day ? day.value : "0";
                data.bus = bus ? bus.value : "0";
                data.allergy = allergy.value.trim();
                data.support = support ? support.value : "0";
                data.departure = data.bus === "1" ? departure.value : "";

                api.request("POST", "/?action=subscribe", data).then((res) => {
                    if (confirmation && form) {
                        confirmation.classList.remove("visually-hidden");
                        form.classList.add("visually-hidden");
                        confirmation.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                    btn.removeAttribute("disabled");
                });
            } else {
                console.log("validation failed");
            }
        });
    }
};